var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPixelTablet(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Component_197_1",
    "data-name": "Component 197 \\u2013 1",
    xmlns: "http://www.w3.org/2000/svg",
    width: 74,
    height: 75,
    viewBox: "0 0 74 75",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_477",
    "data-name": "Group 477",
    transform: "translate(-399 -459)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_157",
    "data-name": "Rectangle 157",
    width: 74,
    height: 75,
    rx: 6,
    transform: "translate(399 459)",
    fill: "#3f4053"
  }), /*#__PURE__*/React.createElement("text", {
    id: "Pixel",
    transform: "translate(413.372 489)",
    fill: "#fff",
    fontSize: 20,
    fontFamily: "HelveticaNeue-Bold, Helvetica Neue",
    fontWeight: 700
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "Pixel")), /*#__PURE__*/React.createElement("text", {
    id: "Tablet",
    transform: "translate(407.5 513.5)",
    fill: "#fff",
    fontSize: 20,
    fontFamily: "HelveticaNeue-Bold, Helvetica Neue",
    fontWeight: 700
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "Tablet")))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPixelTablet);
export default __webpack_public_path__ + "static/media/pixelTablet.c3d23e1cc74bbabdfe6e9b0ad653969b.svg";
export { ForwardRef as ReactComponent };